import React, { ReactNode } from 'react';

import { Box, Paper, Stack, Typography } from '@mui/material';

interface Props {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Sits opposite the title, e.g. a legend or an action. */
  aside?: ReactNode;
  children: ReactNode;
}

export default function SectionCard({ title, subtitle, aside, children }: Props) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, minWidth: 0, overflow: 'hidden' }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1.5}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        sx={{ px: 2.5, py: 2, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Box>
          <Typography variant="h6" fontWeight={600}>
            {title}
          </Typography>
          {!!subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        {aside}
      </Stack>
      <Box sx={{ p: 2.5, minWidth: 0 }}>{children}</Box>
    </Paper>
  );
}
